import React from 'react';

import { bind } from 'bind-decorator';

import { DiaryUpdateEvent } from 'tm3-core/events/diary';

import DiaryStore from 'bz-stores/lib/diary-store';

import Subscribe from 'bz-utilities/modules/plugins/subscribe';

class DiarySubscriber extends React.Component<any> {
  render() {
    return (
      <Subscribe<DiaryUpdateEvent> type={DiaryUpdateEvent} handler={this.onHandle}>
        {this.props.children}
      </Subscribe>
    );
  }

  @bind
  private onHandle(res: DiaryUpdateEvent): void {
    DiaryStore.onUpdateById(res.appointmentId, res.diaryUpdate);
  }
}

export default DiarySubscriber;
